import SearchSpellCorrectedSuggestion from './SearchSpellCorrectedSuggestion';
import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SearchInContextFeedback, UserVoiceSearchTeam } from 'owa-search-diagnostics-view';
import { SearchScenarioId } from 'owa-search-next';
import { lazyGetSearchStore } from 'owa-search-next-lazy';
import * as React from 'react';

export interface SearchHeaderFirstRowContentProps {
    className: string;
    showSpeller?: boolean; // defaults to false
}

const SearchHeaderFirstRowContent = observer(function SearchHeaderFirstRowContent(
    props: SearchHeaderFirstRowContentProps
) {
    const { className, showSpeller = true } = props;

    const getSearchStore = lazyGetSearchStore.tryImportForRender();
    if (!getSearchStore) {
        return null;
    }

    const { currentSearchQueryId, latestRenderedQFTraceId } = getSearchStore(SearchScenarioId.Mail);
    const traceId = currentSearchQueryId || latestRenderedQFTraceId;

    return (
        <>
            {isFeatureEnabled('sea-contextFeedback') && (
                <SearchInContextFeedback
                    cssClass={className}
                    currentSearchQueryId={traceId}
                    userVoiceTeam={UserVoiceSearchTeam.MailSearch}
                />
            )}
            {showSpeller && <SearchSpellCorrectedSuggestion className={className} />}
        </>
    );
});
export default SearchHeaderFirstRowContent;
